document.addEventListener("DOMContentLoaded", () => {
  const scrollableElements = document.querySelectorAll('.scrollable');

  scrollableElements.forEach(scrollableElement => {
    let lenis = new Lenis({
      prevent: (node) => node.classList.contains('modal'),
      wrapper: scrollableElement,
      content: scrollableElement, // In this case, wrapper and content are the same
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
      orientation: 'horizontal',
      gestureOrientation: 'both',
      smoothWheel: true
    });

    lenis.start();

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    const anim = requestAnimationFrame(raf);

    window.addEventListener('beforeunload', () => {
      lenis.destroy();
      cancelAnimationFrame(anim);
    });
  });
});